<template>
  <div class="ks-tags-wrapper" style="margin-bottom: 8px;">
    <k-autocomplete
      :items="availableItems"
      :label="label || title"
      multiple
      clearable
      v-model="val"
      ref="autocomplete"
      @keyup.enter.native.prevent="onEnter"
    >
    </k-autocomplete>
    <div class="ks-tags-chips" style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;" v-if="val && val.length > 0">
      <k-chip
        v-for="(item, index) in val"
        :key="index"
        close
        @click:close="remove(item)"
        size="s"
      >
        {{ item }}
      </k-chip>
    </div>
  </div>
</template>
<script>
import {EventMixin} from '@/lib/mixins.js';
export default {
  mixins: [EventMixin],
  props: {
    'value': {
      type: Object,
      default () { return {}; }
    },
    'name': String,
    'label': String,
    'title': String,
    'items': {
      type: Array,
      default () { return []; }
    }
  },
  computed: {
    availableItems() {
      return this.items.filter(item => !this.val.includes(item));
    },
    val: {
      get () {
        var val = _.get(this.value, this.name) || "";
        return (_.isEmpty(val) ? [] : val.split(","))
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val.join(","));
        this.$emit("input", value);
      }
    }
  },
  methods: {
    onEnter() {
      setTimeout(() => {
        if (!this.$refs.autocomplete) return;
        let currentSearch = this.$refs.autocomplete.searchText;
        if (currentSearch && currentSearch.trim() !== "") {
          const newTag = currentSearch.trim();
          if (!this.val.includes(newTag)) {
            const newVal = [...this.val, newTag];
            this.val = newVal;
          }
          this.$refs.autocomplete.searchText = "";
        }
      }, 50);
    },
    remove (item) {
      this.val.splice(this.val.indexOf(item), 1)
      this.val = [...this.val]
    }
  }
}
</script>
